<template>
  <div class="modal" v-bind:class="{ 'is-active': is_shown }">
    <div class="modal-background"></div>
    <div class="modal-content">
      <full-calendar
        :options="calendarOptions"
        ref="full_calendar"
      ></full-calendar>
    </div>
    <button
      class="modal-close is-large"
      aria-label="close"
      @click="close_modal"
    ></button>
  </div>
</template>
<script>
import {
  put,
  error_message,
  get,
  post,
  error_alert,
  generate_error_message_text,
  get_currency_settings,
} from "@/utils";
import GenericModal from "@/components/generic_modal/Index.vue";
import FullCalendar from "@fullcalendar/vue3";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import moment from "moment";
import { v4 } from "uuid";

export default {
  name: "AvailabilityModal",
  components: { GenericModal, FullCalendar },
  data() {
    let v = this;
    return {
      is_shown: false,
      meta: {},
      error: "",
      events: [],
      calendarOptions: {
        locale: v.$i18n.locale,
        editable: true,
        nowIndicator: true,
        // now: true,
        buttonText: {
          today: v.$t("today"),
          month: v.$t("month"),
          week: v.$t("week"),
          day: v.$t("day"),
        },
        // footerToolbar: {
        //   left: "prev,next today",
        //   center: "title",
        //   right: "dayGridMonth,timeGridWeek,timeGridDay",
        // },
        headerToolbar: {
          left: "prev,next today",
          center: "title",
          right: "dayGridMonth,timeGridWeek,timeGridDay",
        },
        plugins: [dayGridPlugin, interactionPlugin, timeGridPlugin],
        initialView: "timeGridWeek",
        eventClick: function (info) {
          if (info.event._def.publicId) console.log("eventClick", info);

          // v.edit_modal(info.event._def.publicId);
        },
        dateClick: function (info) {
          //console.log("dateClick", info);
          // add event to calendar
          v.calendarOptions.events.push({
            id: v4(),
            start: info.dateStr,
            end: moment(info.dateStr).add(1, "hour").format(),
          });
          setTimeout(() => {
            let els = document.querySelectorAll(".remove.event.icon");
            els.forEach((el) => {
              el.addEventListener("click", function (e) {
                let eid = "";

                if (e.target.tagName == "I") {
                  eid = e.target.parentElement.dataset.eid;
                  // console.log("delete event", eid);
                  // v.delete_event(eid);
                } else if (e.target.tagName == "SPAN") {
                  eid = e.target.dataset.eid;
                  // console.log("delete event", eid);
                }

                if (eid) v.delete_event(eid);
              });
            });
          }, 1000);
          // console.log(v.$refs.full_calendar);
        },
        eventChange: function (info) {
          // console.log("eventChange", info.event._def.publicId);
          let event = v.calendarOptions.events.find(
            (e) => e.id === info.event._def.publicId
          );
          event.start = info.event.start;
          event.end = info.event.end;
        },
        events: [],
        // eventContent: function (arg) {
        //   if (arg.event._def.publicId) {
        //     let start = moment(arg.event.start).format("HH:mm");
        //     let end = moment(arg.event.end).format("HH:mm");
        //     let length = moment(arg.event.end).diff(
        //       moment(arg.event.start),
        //       "minute"
        //     );
        //     return {
        //       html: `<span class="icon remove event" data-eid="${
        //         arg.event._def.publicId
        //       }" >
        //             <i class="fa fa-times has-text-warning"></i>
        //            </span><span>${start} - ${length} ${v.$t("minutes")}</span>`,
        //     };
        //   }
        // },
      },
    };
  },
  computed: {
    is_form_invalid() {
      let v = this;
      return false;
      //return !v.meta.name;
    },
  },
  methods: {
    delete_event(eid) {
      let v = this;
      let evts = v.calendarOptions.events;
      let index = evts.findIndex((e) => e.id == eid);
      if (index > -1) v.calendarOptions.events.splice(index, 1);
    },
    close_modal() {
      let v = this;
      v.is_shown = false;
      // v.$refs.generic_modal.close_modal();
      v.set_initial_state();
    },
    show_modal(availability) {
      let v = this;
      v.set_initial_state();
      v.is_shown = true;
      // v.$refs.generic_modal.show_modal();
      if (availability && availability.length) {
        let evnts = availability.map((e) => {
          let day_of_week = e.iso_day_of_week;
          if (day_of_week == "7") day_of_week = "0";

          return {
            daysOfWeek: [day_of_week],
            startTime: e.from,
            endTime: e.to,
            display: "background",
          };
          // let dte_start = moment().isoWeekday(Number(e.iso_day_of_week));
          // let dte_end = moment().isoWeekday(Number(e.iso_day_of_week));
          // if (dte_start.format("E") == "7") {
          //   dte_start.add(-1, "week");
          //   dte_end.add(-1, "week");
          // }
          // let start = dte_start
          //   .set({
          //     hour: e.from.split(":")[0],
          //     minute: e.from.split(":")[1],
          //   })
          //   //.add(-1, "week")
          //   .toISOString();
          // let end = dte_end
          //   .set({
          //     hour: e.to.split(":")[0],
          //     minute: e.to.split(":")[1],
          //   })
          //   //.add(-1, "week")
          //   .toISOString();

          // return {
          //   start: start,
          //   display: "background",
          //   end: end,
          // };
        });
        // console.log("evnts", evnts);
        v.calendarOptions.events = evnts;
      }
    },
    // edit_modal(uuid) {
    //   let v = this;
    //   v.set_initial_state();

    //   get("/pilates_member/station", { uuid: uuid })
    //     .then((element) => {
    //       v.meta = element;
    //       v.$refs.generic_modal.show_modal();
    //     })
    //     .catch((error) => {
    //       v.error = generate_error_message_text(error);
    //     });
    // },
    save() {
      let v = this;
      let events = v.calendarOptions.events || [];
      events = events.map((e) => {
        return {
          iso_day_of_week: moment(e.start).format("E"),
          from: moment(e.start).format("HH:mm"),
          to: moment(e.end).format("HH:mm"),
        };
      });
      v.$emit("save", events);
      v.$refs.generic_modal.close_modal();
    },
    set_initial_state() {
      let v = this;
      v.meta = {
        settings: {},
      };
      v.error = "";
      v.calendarOptions.events = [];
      // v.uuid = "";
    },
  },
  mounted() {},
  watch: {},
};
</script>
<style></style>
